module.exports = __webpack_public_path__ + "img/download.f9f46fa6.svg";